import { Typography, Fade, Card, CardContent, CardActionArea, Collapse, Avatar, Stack, Unstable_Grid2 as Grid } from "@mui/material";
import { useState } from 'react';
import styles from "./TimelineCardSmall.module.css";

export default function TimelineCardSmall(props) {
    const icon = props.icon;
    const title = props.title;
    const company = props.company;
    const employmentType = props.employmentType;
    const year = props.year;
    const date = props.date;
    const description = props.description;
    const location = props.location;
    const current = props.current;

    const [isExpanded, setIsExpanded] = useState(false);

    const handleClick = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <Card sx={{ backgroundColor: "#575757", width: "80vw", minWidth: 300 }}>
            <CardActionArea onClick={handleClick} >
                <CardContent>
                    <Stack 
                        direction="column"
                        justifyContent="center"
                        alignItems="left"
                    >
                        {isExpanded 
                            ? <Typography variant="subtitle1" color="rgba(255, 255, 255, 87)">{date}</Typography> 
                            : <Typography variant="subtitle1" color="#c2c2c2">{year}</Typography> }
                        <Grid container spacing={2}>
                            <Grid item xs="auto">
                                <Avatar sx={{ backgroundColor: current ? "#2e7d32" : "#0288d1" }}>{icon}</Avatar>
                            </Grid>
                            <Grid item xs>
                                <Typography variant="h5" color="rgba(255, 255, 255, 87)" component="span">{title}</Typography>
                                <Typography variant="body1" color="#4dabf5">{company}</Typography>
                                <Typography variant="body1" color="#c2c2c2">{employmentType}</Typography>
                            </Grid>

                        </Grid>
                            <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                                <div>
                                    <Typography variant="body2" color="#c2c2c2" align="left" sx={{ whiteSpace: 'pre-wrap', mt: 1 }}>{description}</Typography>
                                </div>
                            </Collapse>
                    </Stack>
                </CardContent>
            </CardActionArea>
        </Card>
    );
}